import { Navigate, createHashRouter } from "react-router-dom";
import { AppShell, DEFAULT_ENTRY_PATH } from "./AppShell";
import { RouteErrorPage } from "./RouteErrorPage";

export const router = createHashRouter([
  {
    path: "/",
    element: <AppShell />,
    errorElement: <RouteErrorPage />,
    hydrateFallbackElement: <div className="page-loading" aria-label="正在载入学习中心" />,
    children: [
      { index: true, element: <Navigate to={DEFAULT_ENTRY_PATH} replace /> },
      {
        path: "today",
        lazy: async () => ({ Component: (await import("../pages/TodayPage")).TodayPage }),
      },
      {
        path: "calendar",
        lazy: async () => ({ Component: (await import("../pages/CalendarPage")).CalendarPage }),
      },
      {
        path: "day/:date",
        lazy: async () => ({ Component: (await import("../pages/DayPlanPage")).DayPlanPage }),
      },
      {
        path: "session/:sessionId",
        lazy: async () => ({ Component: (await import("../pages/SessionPage")).SessionPage }),
      },
      {
        path: "knowledge",
        lazy: async () => ({ Component: (await import("../pages/KnowledgePage")).KnowledgePage }),
      },
      {
        path: "knowledge/:moduleId",
        lazy: async () => ({ Component: (await import("../pages/KnowledgeModulePage")).KnowledgeModulePage }),
      },
      {
        path: "chapter/:subject/:chapterId",
        lazy: async () => ({ Component: (await import("../pages/ChapterMapPage")).ChapterMapPage }),
      },
      {
        path: "report/:date",
        lazy: async () => ({ Component: (await import("../pages/ReportPage")).ReportPage }),
      },
      {
        path: "progress",
        lazy: async () => ({ Component: (await import("../pages/ProgressPage")).ProgressPage }),
      },
      {
        path: "mistakes",
        lazy: async () => ({ Component: (await import("../pages/MistakesPage")).MistakesPage }),
      },
      {
        path: "help",
        lazy: async () => ({ Component: (await import("../pages/HelpPage")).HelpPage }),
      },
      {
        path: "edit/plan/:date",
        lazy: async () => ({ Component: (await import("../pages/PlanEditorPage")).PlanEditorPage }),
      },
      {
        path: "settings/data",
        lazy: async () => ({ Component: (await import("../pages/SettingsDataPage")).SettingsDataPage }),
      },
      {
        path: "*",
        lazy: async () => ({ Component: (await import("../pages/NotFoundPage")).NotFoundPage }),
      },
    ],
  },
]);
